<template>
  <div class="prizebody">
    <div class="title">
      <div class="name">帐号</div>
      <div class="product">奖品</div>
    </div>
    <div class="content">
      <div class="item" v-for="(item,index) in lists" :key="index">
        <div class="name">{{item.loginName}}</div>
        <div class="product">抽中了“{{item.content}}”</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lists: {
      type: [Array, Object],
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.name{
  width:45%;
}
.prizebody {
  background: #fff;
  width: 1200px;
  height: 600px;
  box-shadow: 0 5px 20px 0 #aaa;
  .title {
    height: 80px;
    line-height: 80px;
    display: flex;
    color: #fff;
    background: #314e71;
    text-align: left;
    font-size: 30px;
    padding: 0 77px;
    letter-spacing: 8px;
    .name {
      text-indent: 140px;
    }
    .product {
      text-align: center;
      flex:1;
      text-indent:-50px;
    }
  }
  .content {
    padding: 0 77px;
    width: 1200px;
    height: 446px;
    overflow: auto;
    margin-top: 38px;
    &::-webkit-scrollbar {
      width: 0px;
    }
    .item {
      // height: 50px;
      line-height: 50px;
      background: #ededed;
      width: 100%;
      display: flex;
      letter-spacing: 4px;
      color: #a06e3e;
      text-transform: uppercase;
      margin-bottom: 28px;
      font-size: 30px;
      align-items: center;
      &:last-child {
        margin-bottom: 0;
      }
      .name {
        text-indent: 125px;
      }
      .product {
        // text-indent: 60px;
        flex: 1;
        padding:0 15px;
      }
    }
  }
}
</style>
